export const APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/bumpy-international-dating/id1455336523?platform=iphone';
export const GOOGLE_STORE_LINK =
  'https://play.google.com/store/apps/details?id=app.bumpy.android&pli=1';
